import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

const GetNewCodeLink = styled.button`
  display: inline;
  text-decoration: underline;
  background: none;
  border: none;
  padding: 0;
`;

const ActionBar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${tokens.spacer.x6pt5};
`;

const Title = styled.h2`
  ${tokens.text('header4')};
  margin-bottom: ${tokens.spacer.x2};
`;

const Description = styled.div`
  max-width: 368px;
`;

export const VerifyEmailPageStyles = { GetNewCodeLink, ActionBar, Title, Description };
